module.exports = __webpack_public_path__ + "img/bx-headphone.4eab03f3.svg";